export default "__VITE_ASSET__Bdguc0pX__"